import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRolePermission } from '../../hooks/useRolePermission';
import filterrSvg from "../.././assets/images/funnel.svg";
import "../../assets/styles/filterDropdown.css";

export const SearchComponent = (params) => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const { filteredResults,
        search,
        handleKeyDown,
        setSearch,
        removeSearch,
        ApplySearch,
        RefreshList,
        baseColumns,
        selected,
        handleChange,
        moduleName,
        HideFilter,
        data,
        addNew,
        menuRights,
        filterContent,
        hasActiveFilters,
        placeholder
    } = params

    return (
        <div className='d-flex flex-wrap flex-sm-nowrap justify-content-end justify-content-sm-end'>
            <div className="search-section">
                <div className="input-group text-align">
                    <input type="text" className="form-control" placeholder={placeholder || "Search"} value={search} onKeyDown={handleKeyDown} onChange={(e) => setSearch(e.target.value)} />
                    {HideFilter !== "HideFilter" && (
                        <div className="text-align dropdown filter-dropdown quote-filter-control gap-0 d-flex">
                            <div className="input-group-append">
                                {filteredResults?.length !== data?.length && search !== "" && <button className="btn" type="button" onClick={removeSearch}>
                                    <i className="fas fa-times"></i>
                                </button>}
                                <button
                                    className="btn"
                                    type="button"
                                    onClick={ApplySearch}
                                >
                                    <i className="fa fa-search"></i>
                                </button>
                            </div>
                            <button
                                className={`btn filter-btn ${hasActiveFilters ? "filter-active" : ""}`}
                                type="button"
                                id="filterDropdown"
                                aria-haspopup={filterContent ? "true" : undefined}
                                aria-expanded={filterContent ? isFilterOpen : undefined}
                                data-toggle={filterContent ? undefined : "modal"}
                                data-target={filterContent ? undefined : "#filterRightSideModalPopup"}
                                onClick={filterContent ? () => setIsFilterOpen((currentValue) => !currentValue) : undefined}
                                title="Advanced filters"
                                style={{
                                    borderTopLeftRadius: "0px",
                                    borderBottomLeftRadius: "0px",
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                }}
                            >
                                <span>
                                    <img src={filterrSvg}></img>
                                </span>
                            </button>

                            {filterContent && (
                                <div style={{ display: isFilterOpen ? "block" : "none" }}>
                                    {typeof filterContent === "function" ? filterContent(() => setIsFilterOpen(false)) : filterContent}
                                </div>
                            )}
                        </div>)
                    }
                </div>
            </div>
            <div className="text-align">
                <button className="btn refresh-btn" type="button" onClick={(e) => RefreshList()}>
                    <i className="fas fa-redo"></i>
                </button>
            </div>
            {menuRights?.canAdd === true && (<div className="text-right">
                <button className="btn add-new-btn" type="button" onClick={addNew}>
                    Add New
                </button>
            </div>)}
        </div>
    )
}